import React from "react";
import {NotificationModalContext} from "../contexts/NotificationModalContext";

const useNotificationModal = () => {
    return React.useContext(NotificationModalContext);
};

export default useNotificationModal;
